import { render, staticRenderFns } from "./roleDetailDialog.vue?vue&type=template&id=aa25ffe8&scoped=true&"
import script from "./roleDetailDialog.vue?vue&type=script&lang=js&"
export * from "./roleDetailDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa25ffe8",
  null
  
)

export default component.exports